import { twMerge } from 'tailwind-merge';

import { Text } from '@/_components';

import { CurrencyWithPrivacy } from '../currency-with-privacy';

export function WidgetMetricCard({
  title,
  value,
  description,
  icon: Icon,
  className,
  obfuscate = false,
}: {
  title: string;
  value: string | number;
  description?: string;
  icon: React.ComponentType<{ className?: string }>;
  className?: string;
  obfuscate?: boolean;
}) {
  return (
    <section
      className={twMerge(
        'border-c-border-muted flex min-h-36 flex-col gap-3 rounded-xl border bg-white p-4 dark:bg-gray-800',
        className
      )}
    >
      <div className="flex items-center gap-2">
        <Icon className="h-5 min-h-5 w-5 min-w-5 text-gray-600 dark:text-gray-300" />
        <Text className="text-c-card-muted line-clamp-1 text-sm font-medium">{title}</Text>
      </div>

      <Text className="text-c-card-foreground line-clamp-1 text-2xl font-bold break-all">
        {obfuscate ? <CurrencyWithPrivacy value={value} /> : value}
      </Text>
      {description && <Text className="text-c-card-muted text-xs">{description}</Text>}
    </section>
  );
}
